import { Component, OnInit, EventEmitter, ViewChild } from '@angular/core';
import { XPRESS_LOAN} from 'src/models/xpress_loan.model';
import { CREDITCARD_LOAN11 } from 'src/models/creditcard_loan.model';
import { VEHICLE_LOAN,} from 'src/models/vehicle_loan.model';
import { LoanTypeEnum } from 'src/models/loan-type.enum';
import { PERSONAL_LOAN } from 'src/models/personal_loan.model';
import { HE_LOAN } from 'src/models/he_loan.model';
import { ApplicantService } from 'src/shared/applicant.service';
import { AuthService } from 'src/shared/auth.service';
import { CommonService } from 'src/shared/common.service';
import { ValidationErrors } from '@angular/forms';
import { StepOneComponent } from 'src/components/step-one/step-one.component';
import * as $ from 'jquery';
import * as _ from 'lodash';
import { base_applicant_type, BASE_CUSTOM_QUESTIONSCUSTOM_QUESTION, BASE_EMPLOYMENTEmployment_status } from 'src/models/common.model';
import { BASE_APPLICANTCitizenship, BASE_APPLICANTGender } from 'src/models/creditcard_loan.model';
import { AppComponent } from '../app.component';
import { JointApplicantModalComponent } from 'src/components/step-one/joint-applicant-modal/joint-applicant-modal.component';
import { ApiService } from 'src/shared/api.service';
import { ActivatedRoute } from '@angular/router';
import { Util } from 'src/shared/util';
import { zip } from 'rxjs';
import { NmaoWfService } from 'src/shared/nmao-wf.service';




@Component({
  selector: 'app-applicant-loan',
  templateUrl: './applicant-loan.component.html',
  styleUrls: ['./applicant-loan.component.css']
})
export class ApplicantLoanComponent implements OnInit {

  steps = [
    {
      id: 1,
      headerText: "Application"
    },
    {
      id: 2,
      headerText: "Review"
    },
    {
      id: 3,
      headerText: "Confirm"
    }
  ]

  public static currentStepId: any;
  submitHistory: any;

  creditCardLoan: CREDITCARD_LOAN11;
  vehicleLoan: VEHICLE_LOAN;
  personalLoan: PERSONAL_LOAN;
  heLoan: HE_LOAN;

  xpressLoan: XPRESS_LOAN = new XPRESS_LOAN();

  eligibilityModel ={
    qualifyingEmployer:{},
    eligibilityRelationship:{
      isChecked: false,
      name:"",
      phone:"",
    },
    employee_of_lender_type:{
      isChecked: false
    }
  }

  selectedLoanType: LoanTypeEnum;
  selectedProducts = [];
  soResponses: any ;
  public static addJointApp: EventEmitter<any> = new EventEmitter<any>();

  public static copyAddressFromMainApp: EventEmitter<boolean> = new EventEmitter<boolean>();

  public static forceFinalPageError = false;

  public static currentChannel: any;
  public static refChannel : string = '';
  public static pcQuery : string = '';

  public static isCoBrand = false;

  public static defaultPrimarySavingProduct;

  public static sessionId = '';

  validationErrors: ValidationErrors = {};

  public entity_Token = "";
  public journeyApplicationToken = "";
  public static onUploadAlloyDocumentComplete: EventEmitter<any> = new EventEmitter<any>();

  AppComponent =  AppComponent;
  ApplicantLoanComponent = ApplicantLoanComponent;
  customQuestions: BASE_CUSTOM_QUESTIONSCUSTOM_QUESTION[] = [
    //hearAboutUsModel 0
    {
      CUSTOM_QUESTION_ANSWER: [{ answer_text: "", answer_value: "" }],
      question_name: "{REFERRAL}",
      question_type: "DROPDOWN"
    },
    // promotion code 1
    {
      CUSTOM_QUESTION_ANSWER: [{ answer_text: "", answer_value: "" }],
      question_name: "{PROMO}",
      question_type: "TEXTBOX"
    },
    // WITHHOLDING 2
    {
      CUSTOM_QUESTION_ANSWER: [],
      question_name: "{WITHHOLDING}",
      question_type: "DROPDOWN"
    },

    // consent 3
    {
      CUSTOM_QUESTION_ANSWER: [],
      question_name: "{TCPA}",
      question_type: "DROPDOWN"
    },

    //consentToContactMP 4
    {
      CUSTOM_QUESTION_ANSWER: [],
      question_name: "{TCPA_MKT}",
      question_type: "DROPDOWN"
    },


    //Text Opt-In 5
    {
      CUSTOM_QUESTION_ANSWER: [],
      question_name: "Text Opt-In",
      question_type: "DROPDOWN"
    },

    //APPFROM 6
    {
      CUSTOM_QUESTION_ANSWER: [{ answer_text: "ONLINE", answer_value: "ONLINE" }],
      question_name: "{APPFROM}",
      question_type: "CHECKBOX"
    },

    //JOINT_APP 7
    {
      CUSTOM_QUESTION_ANSWER: [{ answer_text: "NO", answer_value: "NO" }],
      question_name: "{JOINT_APP}",
      question_type: "DROPDOWN"
    },
    // Note: CREDRPT (index 8) is now dynamically added in common-applicant-form.component.ts
    // only when applicationType == 2 (type 2 products)
  ];


  constructor(private applicantService: ApplicantService, private authService: AuthService, private commonService: CommonService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private activatedRoute: ActivatedRoute, private nmaoWfService: NmaoWfService) {
    try{
      this.authService.getToken().subscribe(async r => {
        this.commonService.accessToken = r.access_token;    
      })
    }catch{}
    finally{
      this.xpressLoan.version  = 5.248;
      ApplicantLoanComponent.currentStepId = 1;
      // setTimeout(() => {
      //   this.initTestApp();
      // }, 7000);
    }

    this.route.queryParams.subscribe(params => {
      ApplicantLoanComponent.refChannel = this.commonService.attributionData?.campaign_id || params['ref'] || ApplicantLoanComponent.refChannel;
      ApplicantLoanComponent.pcQuery = params['pc']?.toLowerCase();
      zip(this.apiService.getChannelByCurrentUri(ApplicantLoanComponent.refChannel),
          this.apiService.getEmployerNames()).subscribe(([r1, r2])=>{
            if(r1 && r2){
              ApplicantLoanComponent.currentChannel = r1;
              ApplicantLoanComponent.isCoBrand = r1.channelTypeId == 3 && r1.isActive;
              var employerName = _.find(r2, em => em.channelId == ApplicantLoanComponent.currentChannel.id);
              if(ApplicantLoanComponent.isCoBrand){
                if(ApplicantLoanComponent.currentChannel.channelName && employerName){
                  this.eligibilityModel.qualifyingEmployer ={displayName:employerName.displayName, value:employerName.value}
                }else{
                  this.eligibilityModel.qualifyingEmployer ={displayName:'Surfrider Foundation', value:4018}
                }
                let questionAppFrom = _.find(this.customQuestions, cq=>{
                  return cq.question_name == '{APPFROM}'
                }) 
                var section = _.find(ApplicantLoanComponent.currentChannel.channelSectionSubscriptions, css=>{
                  return css.sectionId == 1;
                })
                if(section){
                  var md = JSON.parse(section.metaData);
                  questionAppFrom.CUSTOM_QUESTION_ANSWER = [{ answer_text: md.name, answer_value: md.value }]
    
                  this.customQuestions.push(
                    {
                      CUSTOM_QUESTION_ANSWER: [{ answer_text: md.name, answer_value: md.value }],
                      question_name: "BDOREFERRAL",
                      question_type: "DROPDOWN"
                    },
                  )
                }
               
                  // $('#bg-main-id').css('color', 'black');   
                  // $('#bg-main-id').css('background-color', 'black');    
                  if(ApplicantLoanComponent.currentChannel.accentColor){
    
                    $('#bg-main-id').css('background-image', `linear-gradient(to top right,${ApplicantLoanComponent.currentChannel.accentColor.split('-')[0]},${ApplicantLoanComponent.currentChannel.accentColor.split('-')[1]} )`);
                  }
                  
                
                
              }
            }
          })
     
      

  });



  }

  ngOnInit(): void {
    ApplicantLoanComponent.sessionId = Util.generateId();
   

    const _this = this;
    window.addEventListener("beforeunload", function (e) {
      var confirmationMessage = "If you proceed then your form won't be saved and you will have to refill the form.";  
      if(ApplicantLoanComponent.currentStepId ==2.5){
        try{
          var fundingLog = {
            appId : _this.submitHistory.XAId,
            submitHistoryId : _this.submitHistory.id,
            appEvent : "Try to close funding page",
          } as any;
          _this.apiService.saveFundingLog(fundingLog).subscribe(r=>{})
        }catch{}
      }
      e.returnValue = confirmationMessage;     // Gecko, Trident, Chrome 34+
          return confirmationMessage;              // Gecko, WebKit, Chrome <34
      });



    this.initData();
    this.creditCardLoan = this.applicantService.initDataCreditCard();

    //For type 2
    var applicationType = this.activatedRoute.snapshot.queryParams["at"];
    var ltId = this.activatedRoute.snapshot.queryParams["lt"];

    if(applicationType && applicationType == 2 && ltId && ltId == 6){
      this.personalLoan = this.applicantService.initDataPersonal();
    }
    if(applicationType && applicationType == 2 && ltId && ltId == 5){
      this.vehicleLoan = this.applicantService.initDataVehicle();
    }
    ApplicantLoanComponent.addJointApp.subscribe(r => {

      //joint applicant
      this.creditCardLoan.APPLICANTS.APPLICANT[0].SPOUSE = r.creditCardApplicant;
      //SET APPLICANT_TYPE FOR DECISION
      this.creditCardLoan.APPLICANTS.APPLICANT[0].SPOUSE.applicant_type = base_applicant_type.C;
      this.xpressLoan.APPLICANTS[0].SPOUSE = r.xpressApplicant;


      if(this.vehicleLoan){
        this.vehicleLoan.APPLICANTS.APPLICANT[0].SPOUSE  = r.vehicleApplicant;
        this.vehicleLoan.APPLICANTS.APPLICANT[0].SPOUSE.applicant_type = base_applicant_type.C;
      }
      if(this.personalLoan){
        this.personalLoan.APPLICANTS.APPLICANT[0].SPOUSE = r.personalApplicant;
        this.personalLoan.APPLICANTS.APPLICANT[0].SPOUSE.applicant_type = base_applicant_type.C;
      }
      if(this.heLoan){
        this.heLoan.APPLICANTS.APPLICANT[0].SPOUSE = r.heApplicant;
        this.heLoan.APPLICANTS.APPLICANT[0].SPOUSE.applicant_type = base_applicant_type.C;

        console.log(this.heLoan.APPLICANTS.APPLICANT[0].SPOUSE )
      }


     if(this.xpressLoan.APPLICANTS[0].SPOUSE.ssn === this.xpressLoan.APPLICANTS[0].ssn){

        this.validationErrors.ssn =  {
          'hasSamessn': 'hasSamessn'
         } as ValidationErrors;
     }else{
        delete  this.validationErrors.ssn ;
     }
    })

    ApplicantLoanComponent.copyAddressFromMainApp.subscribe(r=>{
      JointApplicantModalComponent.copyAddressFromMainApp.emit(this.creditCardLoan.APPLICANTS.APPLICANT[0]);
    })

    // console.log("----------------------------------------------------------")

    // var testPayloadEncryptedModel = this.nmaoWfService.encryptRsa(JSON.stringify({"bank":"ACB","name":"NVA","card":"4221123412341234"}));
    // var testPayload = {
    //   loanId : '90a4dcac7d6e41469e9c7ab60ddb65f2',
    //   requestJsonCCsEncrypted: testPayloadEncryptedModel
    // }
    // this.apiService.fundDeposit(testPayload, '7089D365-BCED-45A0-BA2B-08DE29188D5A').subscribe(r =>{})

  }

  initData() {
    this.xpressLoan.SYSTEM =[
      {
        BRANCH: {
          name: "test"
        } as any
      } as any
    ]
    this.xpressLoan.LOAN_INFO = {
      requirement_description_value: "",
    } as any;
    this.xpressLoan.APPLICANTS = [this.applicantService.initXpressApplicant()];
    this.xpressLoan.COMMENTS = {} as any;
  }

  productsHaveChanged(e) {
    this.selectedProducts = _.uniqBy(e, 'id'); 
    var ccLoanProduct = _.find(this.selectedProducts, {loan_type: LoanTypeEnum.CC, productGroupId:4});
    if(ccLoanProduct!=null){
      this.creditCardLoan.LOAN_INFO.requested_card_name = this.creditCardLoan.LOAN_INFO.card_name  = ccLoanProduct.name;
      this.creditCardLoan.LOAN_INFO.purpose_type= "New Card";   
    }
  }

  // scrollToTopPage() {
  //   $("html, body").stop().animate({ scrollTop: 0 }, 500, 'swing'); //scropTop of page
  // }
  
  handleEntityTokenChange(eventData : any){
    this.entity_Token = eventData.entityToken;
    this.journeyApplicationToken = eventData.journeyApplicationToken;
    ApplicantLoanComponent.currentStepId = 2.1;
  }
  
  onUploadCompleted(event){
    ApplicantLoanComponent.currentStepId = 2;
    ApplicantLoanComponent.onUploadAlloyDocumentComplete.emit(event);
  }

  vehicleLoanChange(e){
    this.vehicleLoan = e;
  }
  personalLoanChange(e){
    this.personalLoan = e;
  }
  heLoanChange(e){
    this.heLoan = e;
  }

  submitHistoryChanged(event){
    this.submitHistory = event.submitHistory;
    if(event.selectedLoanType){
      this.selectedLoanType = event.selectedLoanType;
    }
    if(event.soResponses){
      this.soResponses = event.soResponses;
    }
  }

  initTestApp() {
    // Fill creditCardLoan applicant
    const applicant = this.creditCardLoan.APPLICANTS.APPLICANT[0];

    // Personal Info
    applicant.first_name = 'Test';
    applicant.last_name = 'User';
    applicant.ssn = '000-00-0002';
    applicant.dob = '1990-01-15' as any;
    applicant.mother_maiden_name = 'Smith';
    applicant.citizenship = BASE_APPLICANTCitizenship.USCITIZEN;


    // Current Address with occupancy info
    applicant.CURRENT_ADDRESS = {
      LOOSE_ADDRESS: {
        street_address_1: '123 Test Street',
        street_address_2: '',
        city: 'Los Angeles',
        state: 'CA',
        zip: '90001',
        is_current: 'Y'
      },
      occupancy_status: 1,
      occupancy_duration: 30
    } as any;

    // Contact Info
    applicant.CONTACT_INFO.email = 'test@example.com';
    applicant.CONTACT_INFO.cell_phone = '310-555-1234';
    applicant.CONTACT_INFO.home_phone = '310-555-1234';

    // Employment Info
    applicant.FINANCIAL_INFO.CURRENT_EMPLOYMENT[0].employment_status = BASE_EMPLOYMENTEmployment_status.EM;
    applicant.FINANCIAL_INFO.CURRENT_EMPLOYMENT[0].employer = 'Test Company';
    applicant.FINANCIAL_INFO.CURRENT_EMPLOYMENT[0].occupation = 'Engineer';
    applicant.FINANCIAL_INFO.CURRENT_EMPLOYMENT[0].employed_months = '24';
    applicant.FINANCIAL_INFO.CURRENT_EMPLOYMENT[0].employment_start_date = '2022-01-01' as any;

    // Monthly Income
    applicant.FINANCIAL_INFO.MONTHLY_INCOME.monthly_income_base_salary = 5000;

    // Fill xpressLoan applicant
    const xpressApplicant = this.xpressLoan.APPLICANTS[0];
    xpressApplicant.first_name = applicant.first_name;
    xpressApplicant.last_name = applicant.last_name;
    xpressApplicant.ssn = applicant.ssn;
    xpressApplicant.dob = applicant.dob;
    xpressApplicant.mother_maiden_name = applicant.mother_maiden_name;
    xpressApplicant.CURRENT_ADDRESS = applicant.CURRENT_ADDRESS as any;
    xpressApplicant.email = applicant.CONTACT_INFO.email;
    xpressApplicant.cell_phone = applicant.CONTACT_INFO.cell_phone;
    xpressApplicant.home_phone = applicant.CONTACT_INFO.home_phone;
    xpressApplicant.FINANCIAL_INFO.employment_status = applicant.FINANCIAL_INFO.CURRENT_EMPLOYMENT[0].employment_status as any;
    xpressApplicant.FINANCIAL_INFO.employer = applicant.FINANCIAL_INFO.CURRENT_EMPLOYMENT[0].employer;
    xpressApplicant.FINANCIAL_INFO.monthly_income_base_salary = applicant.FINANCIAL_INFO.MONTHLY_INCOME.monthly_income_base_salary;

    // ID Card Info
    xpressApplicant.ID_CARD = {
      card_type: 'DRIVERS_LICENSE',
      card_number: 'D1234567',
      state: 'CA',
      date_issued: '2020-01-15' as any,
      exp_date: '2028-01-15' as any
    } as any;

    // Set eligibility model (qualifying employer)
    this.eligibilityModel.qualifyingEmployer = { displayName: 'None', value: '0' };

    // Use jQuery to set form input values and trigger Angular change detection
    setTimeout(() => {
      // Helper to set input value and trigger events
      const setInputValue = (selector: string, value: any) => {
        const el = $(selector);
        if (el.length) {
          el.val(value);
          el[0].dispatchEvent(new Event('input', { bubbles: true }));
          el[0].dispatchEvent(new Event('change', { bubbles: true }));
        }
      };

      // Set occupancy years/months for address
      setInputValue('input[formcontrolname="occupancy_status_year"]', '2');
      setInputValue('input[formcontrolname="occupancy_status_month"]', '6');

      // Set employer name
      setInputValue('input[formcontrolname="employerName"]', 'Test Company');

      // Set employment duration years/months
      setInputValue('input[formcontrolname="occupancy_status_year_financial"]', '2');

      // Trigger click on Continue button
      setTimeout(() => {
        const continueBtn = $('button:contains("Continue")');
        if (continueBtn.length) {
          continueBtn.trigger('click');
        }
      }, 500);
    }, 100);
  }

}
